import {
  makeVar,
  ReactiveVar,
  useReactiveVar,
} from '@apollo/client';

let isHeaderCatalogMenuOpenVar: ReactiveVar<boolean> = (
  makeVar<boolean>(false)
);
let isHeaderUserMenuOpenVar: ReactiveVar<boolean> = (
  makeVar<boolean>(false)
);

if (typeof window !== 'undefined') {
  if (!window.IS_HEADER_CATALOG_MENU_OPEN) {
    window.IS_HEADER_CATALOG_MENU_OPEN = makeVar<boolean>(false);
  }
  if (!window.IS_HEADER_USER_MENU_OPEN) {
    window.IS_HEADER_USER_MENU_OPEN = makeVar<boolean>(false);
  }

  isHeaderCatalogMenuOpenVar = window.IS_HEADER_CATALOG_MENU_OPEN;
  isHeaderUserMenuOpenVar = window.IS_HEADER_USER_MENU_OPEN;
}

export const useHeaderState = () => {
  const isHeaderCatalogMenuOpen = useReactiveVar(isHeaderCatalogMenuOpenVar);
  const isHeaderUserMenuOpen = useReactiveVar(isHeaderUserMenuOpenVar);

  const handleOpenHeaderCatalogMenu = () => {
    isHeaderCatalogMenuOpenVar(true);
    isHeaderUserMenuOpenVar(false);
  };

  const handleCloseHeaderCatalogMenu = () => {
    isHeaderCatalogMenuOpenVar(false);
    isHeaderUserMenuOpenVar(false);
  };

  const handleToggleHeaderCatalogMenu = () => {
    isHeaderCatalogMenuOpenVar(!isHeaderCatalogMenuOpen);
    isHeaderUserMenuOpenVar(false);
  };

  const handleOpenHeaderUserMenu = () => {
    isHeaderUserMenuOpenVar(true);
    isHeaderCatalogMenuOpenVar(false);
  };

  const handleCloseHeaderUserMenu = () => {
    isHeaderUserMenuOpenVar(false);
    isHeaderCatalogMenuOpenVar(false);
  };

  const handleToggleHeaderUserMenu = () => {
    isHeaderUserMenuOpenVar(!isHeaderUserMenuOpen);
    isHeaderCatalogMenuOpenVar(false);
  };

  return {
    isHeaderCatalogMenuOpen,
    isHeaderUserMenuOpen,
    handleOpenHeaderCatalogMenu,
    handleCloseHeaderCatalogMenu,
    handleToggleHeaderCatalogMenu,
    handleOpenHeaderUserMenu,
    handleCloseHeaderUserMenu,
    handleToggleHeaderUserMenu,
  };
};
